/**
 * @prettier
 * @flow
 */
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import AddIcon from '@material-ui/icons/Add';
import React from 'react';
import { translate } from 'src/utils/translate/translate';

export function CreateToolbarButton({ tooltip, onClick }: Props) {
    return (
        <Tooltip title={tooltip || translate('Create')}>
            <IconButton onClick={onClick}>
                <AddIcon />
            </IconButton>
        </Tooltip>
    );
}

type Props = {
    tooltip?: string,
    onClick?: Function,
};
